module.exports = __webpack_public_path__ + "intercambio.jpg?94ebaa0bf0a7cc65817b7e0374f24a41";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projetos/intercambio.jpg
// module id = 124
// module chunks = 0